export function hexToHslTriplet(hex) {
  let h = (hex || "#000000").replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  const r = parseInt(h.slice(0, 2), 16) / 255;
  const g = parseInt(h.slice(2, 4), 16) / 255;
  const b = parseInt(h.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let hh = 0, s = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) hh = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) hh = (b - r) / d + 2;
    else hh = (r - g) / d + 4;
    hh *= 60;
  }
  return `${Math.round(hh)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

const varLines = (palette) =>
  Object.entries(palette || {})
    .map(([k, v]) => `--${k.replace(/_/g, "-")}: ${hexToHslTriplet(v)};`)
    .join("\n");

export function buildThemeCss(theme) {
  return `:root{\n${varLines(theme.light)}\n--radius: ${theme.radius || "0.5rem"};\n}\n` +
    `.dark{\n${varLines(theme.dark)}\n}\n` +
    `h1,h2,h3,h4,.font-heading{font-family:'${theme.font_heading || "Outfit"}',sans-serif !important;}\n` +
    `body{font-family:'${theme.font_body || "Inter"}',sans-serif !important;}`;
}

function ensureFonts(theme, id) {
  const families = [theme.font_heading || "Outfit", theme.font_body || "Inter"];
  const href = `https://fonts.googleapis.com/css2?${families.map((f) => `family=${encodeURIComponent(f)}:wght@400;500;600;700;800`).join("&")}&display=swap`;
  let link = document.getElementById(id);
  if (!link) {
    link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }
  if (link.href !== href) link.href = href;
}

export function applyTheme(theme, elementId = "astral-theme") {
  const existing = document.getElementById(elementId);
  if (!theme) {
    if (existing) existing.remove();
    const fonts = document.getElementById(`${elementId}-fonts`);
    if (fonts) fonts.remove();
    return;
  }
  let el = existing;
  if (!el) {
    el = document.createElement("style");
    el.id = elementId;
    document.head.appendChild(el);
  } else {
    document.head.appendChild(el);
  }
  el.textContent = buildThemeCss(theme);
  ensureFonts(theme, `${elementId}-fonts`);
}

export function applyBranding(branding) {
  if (!branding) return;
  if (branding.browser_title) document.title = branding.browser_title;
  if (branding.favicon) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = branding.favicon;
  }
}

export function contrastRatio(hex1, hex2) {
  const lum = (hex) => {
    let h = hex.replace("#", "");
    if (h.length === 3) h = h.split("").map((c) => c + c).join("");
    const chan = (c) => {
      c /= 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    };
    return 0.2126 * chan(parseInt(h.slice(0, 2), 16)) + 0.7152 * chan(parseInt(h.slice(2, 4), 16)) + 0.0722 * chan(parseInt(h.slice(4, 6), 16));
  };
  const l1 = lum(hex1), l2 = lum(hex2);
  return Math.round(((Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05)) * 100) / 100;
}
